import { render, staticRenderFns } from "./blockChainBrowser.vue?vue&type=template&id=449d64bc&scoped=true&"
import script from "./blockChainBrowser.vue?vue&type=script&lang=ts&"
export * from "./blockChainBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./blockChainBrowser.vue?vue&type=style&index=0&id=449d64bc&scoped=true&lang=css&"
import style1 from "./blockChainBrowser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449d64bc",
  null
  
)

export default component.exports